module.exports = __webpack_public_path__ + "static/media/mobile-android.f1f91ea6.svg";